// extracted by mini-css-extract-plugin
export default {"index":"view_index__jhiYd"};